import type { FC } from "react";

import { Skeleton } from "@recobra/ui/skeleton";

import { InlineFormError } from "../../lib";
import { getErrorMessage } from "../../lib/api";
import type { TaskRequirementContext } from "./useTaskRequirementContext";

/** Stands in for the checklist while the task's context is loading or could not be read. */
export const TaskContextStatus: FC<{ context: TaskRequirementContext }> = ({ context }) => {
  if (context.error) return <InlineFormError message={getErrorMessage(context.error)} />;
  if (context.isLoading && !context.taskType) return <Skeleton className="h-20 w-full" />;
  return null;
};
